import * as React from "react";
import "./plainTextBlock.scss";

export const PlainTextBlock = ({specField}) => {

    return(
        <div className="plainTextBlock-72g">
            <p>{specField.data}</p>
        </div>
    );
}